import React, { Suspense, useEffect, useLayoutEffect, useRef } from 'react';
//import "../../scss/templates.scss";
import PageLoader from '../../common/PageLoader';
// import { handleResizing } from '../../helper';
import { render } from "react-dom";
import { DUMMY_LETTERS } from '../../../constants/defaultData';


// import TemplateOne from "./TemplateOne/Templates";
// import TemplateTwo from "./TemplateTwo/Templates";
// import TemplateThree from "./TemplateThree/Templates";
// import TemplateFour from "./TemplateFour/Templates";
// import TemplateFive from "./TemplateFive/Templates";
// import TemplateSix from "./TemplateSix/Templates";
// import TemplateSeven from "./TemplateSeven/Templates";
// import TemplateEight from "./TemplateEight/Templates";
// import TemplateNine from "./TemplateNine/Templates";
let TPL = {}

// TPL['template-ten'] = React.lazy(() => import("./TemplateTen/Template10V1"));
// TPL['template-ten-v2'] = React.lazy(() => import("./TemplateTen/Template10V2"));
// TPL['template-ten-v3'] = React.lazy(() => import("./TemplateTen/Template10V3"));
// TPL['template-ten-v4'] = React.lazy(() => import("./TemplateTen/Template10V4"));
// TPL['template-ten-v5'] = React.lazy(() => import("./TemplateTen/Template10V5"));

TPL['template-eleven'] = React.lazy(() => import("./TemplateEleven/Template11"));

TPL['template-twelve'] = React.lazy(() => import("./TemplateTwelve/Template12"));

TPL['template-thirteen'] = React.lazy(() => import("./TemplateThirteen/Template13"));

TPL['template-fourteen'] = React.lazy(() => import("./TemplateFourteen/Template14"));

// TPL['template-fifteen'] = React.lazy(() => import("./TemplateFifteen/Template15"));

TPL['template-sixteen'] = React.lazy(() => import("./TemplateSixteen/Template16"));

TPL['template-sixteen-v2'] = React.lazy(() => import("./TemplateSixteen/Template16V2"));

TPL['template-seventeen'] = React.lazy(() => import("./TemplateSeventeen/Template17"));

TPL['template-eighteen'] = React.lazy(() => import("./TemplateEighteen/Template18"));

TPL['template-nineteen'] = React.lazy(() => import("./TemplateNineteen/Template19"));

// TPL['template-twenty'] = React.lazy(() => import("./TemplateTwenty/Template20"));

// TPL['template-twenty-one'] = React.lazy(() => import("./TemplateTwentyOne/Template21"));

TPL['template-twenty-three'] = React.lazy(() => import("./TemplateTwentyThree/Template23"));

TPL['template-twenty-three-v2'] = React.lazy(() => import("./TemplateTwentyThree/Template23V2"));

TPL['template-twenty-four'] = React.lazy(() => import("./TemplateTwentyFour/Template24"));


const LetterPreview = (props) => {
  const scale = props.hasOwnProperty('scale') ? props.scale : '';
  const selected_template = props.data?.active_template;
    //console.log(selected_template)
  //const selected_template = 'template-docx';
  const TplName = TPL[selected_template] ?? 'template-eleven';
  let _t = props.data;
  const DR = DUMMY_LETTERS;

  const coverletter =  _t
  // const find_last_hyphen = /-v\d+$/;
  // const final_selected_template = selected_template ? selected_template.replace(find_last_hyphen, '') : 'template-one';
  const mergeDummy = () => {
    let t = { from: {...coverletter.from}, to: {...coverletter.to}, summary: {...coverletter.summary} }, src, dest
    //Replace all heading fields in case of empty field
    //console.log(t.summary.content, 'show content')
    // if(!rm?.summary?.content) rm.summary = DR.summary
    if(!t.summary.content)  {
      t.summary.content = DR.summary.content
      t.summary.date = DR.summary.date
    }
    if (!t.from.fname.length)  Object.keys(t.from).map(k =>  (DR.from.hasOwnProperty(k) && !t.from[k].length && (t.from[k] = DR.from[k])));
    if (!t.to.fname.length)  Object.keys(t.to).map(k =>  (DR.to.hasOwnProperty(k) && !t.to[k].length && (t.to[k] = DR.to[k])));
    //Assign remaining values of coverletter object as itis
    Object.keys(coverletter).map(k => t.hasOwnProperty(k) || (t[k] = coverletter[k])) 
    // (!t.to.fname?.length || !t.to.profile?.length) && (t.to = DR.to)
    //Show dummy data for first time, finally remove all as user start adding description
    return t
  }

  const getTemplate = () => {    
    return (<TplName data={props.hasOwnProperty('no_dummy') ? coverletter : mergeDummy()}  scale={scale} />);
  }

  return (
    <div className={`resume-container no-print-border`}>
      {props.hasOwnProperty('nolazy') ? getTemplate() : <Suspense fallback={<PageLoader />}>{getTemplate()}</Suspense>}
    </div>
  );
}

export default LetterPreview;